import type { FC, PropsWithChildren } from 'react';

import styles from './ModalFooter.module.scss';

export const ModalFooter: FC<PropsWithChildren> = ({ children }) => {
	return <div className={styles.footer}>{children}</div>;
};
